__turbopack_context__.v({
  "active-month-indicator": "Charts-module-scss-module__q-nwwa__active-month-indicator",
  "always-active-tooltip": "Charts-module-scss-module__q-nwwa__always-active-tooltip",
  "chart": "Charts-module-scss-module__q-nwwa__chart",
  "chart-area-wrapper": "Charts-module-scss-module__q-nwwa__chart-area-wrapper",
  "chart-scrollable-width": "Charts-module-scss-module__q-nwwa__chart-scrollable-width",
  "chart-wrapper": "Charts-module-scss-module__q-nwwa__chart-wrapper",
  "colored-box": "Charts-module-scss-module__q-nwwa__colored-box",
  "first": "Charts-module-scss-module__q-nwwa__first",
  "label": "Charts-module-scss-module__q-nwwa__label",
  "label-value": "Charts-module-scss-module__q-nwwa__label-value",
  "last": "Charts-module-scss-module__q-nwwa__last",
  "line": "Charts-module-scss-module__q-nwwa__line",
  "marker": "Charts-module-scss-module__q-nwwa__marker",
  "mobile": "Charts-module-scss-module__q-nwwa__mobile",
  "price-history": "Charts-module-scss-module__q-nwwa__price-history",
  "scrollable": "Charts-module-scss-module__q-nwwa__scrollable",
  "scrolling-labels-canvas": "Charts-module-scss-module__q-nwwa__scrolling-labels-canvas",
  "self-initiated": "Charts-module-scss-module__q-nwwa__self-initiated",
  "tooltip": "Charts-module-scss-module__q-nwwa__tooltip",
  "tooltip-container": "Charts-module-scss-module__q-nwwa__tooltip-container",
  "tooltip-content-wrapper": "Charts-module-scss-module__q-nwwa__tooltip-content-wrapper",
  "tooltip-description": "Charts-module-scss-module__q-nwwa__tooltip-description",
});
